import { Component, forwardRef, input, model, numberAttribute, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValidationOutputComponent } from "../validation-output/validation-output.component";
import { LabelComponent } from '../label/label.component';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [ValidationOutputComponent, LabelComponent]
})
export class TextareaComponent implements ControlValueAccessor {
  value = model<string | null | undefined>('');
  rows = input(3);
  label = input<string>();
  htmlFor = input<string>();
  textareaStyleClass = input<string>();
  placeholder = input<string>('');
  errorMessage = input<string>();
  maxLength = input<number>();

  onChange = (value: string) => { };
  onTouched = () => { };
  writeValue(value: string): void {
    this.value.set(value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    const oldValue = this.value() ?? '';
    if (!this.canAddMore(value)) {
      inputElement.value = oldValue;
      return;
    }
    this.value.set(value);
    this.onChange(value);
    this.onTouched();
  }

  canAddMore(value: string) {
    const maxLength = this.maxLength();
    if (typeof maxLength !== 'number') return true;
    return value.length < maxLength;
  }
}
